<pf-text type="description" *ngIf="pfTitle">{{ pfTitle }}</pf-text>
<nz-segmented
    [nzOptions]="segmentedOptions"
    [(ngModel)]="model"
    (ngModelChange)="handleModelChange($event)"></nz-segmented>
